// Approx city-centre coordinates so the delivery pin map opens on the recipient's city.
export const CITY_CENTERS = {
  casablanca: { lat: 33.5731, lng: -7.5898 },
  marrakech: { lat: 31.6295, lng: -7.9811 },
  rabat: { lat: 34.0209, lng: -6.8416 },
  tangier: { lat: 35.7595, lng: -5.834 },
  agadir: { lat: 30.4278, lng: -9.5981 },
  fes: { lat: 34.0331, lng: -5.0003 },
  meknes: { lat: 33.8935, lng: -5.5473 },
  tetouan: { lat: 35.5785, lng: -5.3684 },
  oujda: { lat: 34.6814, lng: -1.9086 },
  kenitra: { lat: 34.261, lng: -6.5802 },
  "el-jadida": { lat: 33.2549, lng: -8.5079 },
  essaouira: { lat: 31.5085, lng: -9.7595 },
};

const norm = (s = "") =>
  s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\s'’]/g, "");

const BY_NAME = {
  casablanca: "casablanca", marrakech: "marrakech", rabat: "rabat",
  tanger: "tangier", tangier: "tangier", agadir: "agadir", fes: "fes", fès: "fes",
  meknes: "meknes", meknès: "meknes", tetouan: "tetouan", tétouan: "tetouan",
  oujda: "oujda", kenitra: "kenitra", kénitra: "kenitra", eljadida: "el-jadida",
  essaouira: "essaouira",
};

export const cityCenter = (city) => {
  if (!city) return null;
  if (city.key && CITY_CENTERS[city.key]) return CITY_CENTERS[city.key];
  const key = BY_NAME[norm(city.name || "")];
  return key ? CITY_CENTERS[key] : null;
};
